export const setRegisterProductData = (payload) => ({
  type: 'SET_REGISTER_PRODUCT_DATA',
  payload,
});

export const clearRegisterProductData = () => ({
  type: 'CLEAR_REGISTER_PRODUCT_DATA',
});
